import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
import _imports_0 from './../../assets/image/qcpay/h5/menu.png';
import _imports_1 from './../../assets/image/address/contury.png';
import _imports_2 from './../../assets/image/payList/desktop.png';
import _imports_3 from './../../assets/image/payList/refresh.png';
const _hoisted_1 = {
  class: "top"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "top-right-title"
};
const _hoisted_4 = {
  class: "is-active"
};
const _hoisted_5 = {
  class: "is-active"
};
const _hoisted_6 = {
  class: "is-active"
};
const _hoisted_7 = {
  class: "is-active"
};
const _hoisted_8 = {
  class: "is-active"
};
const _hoisted_9 = {
  key: 0,
  class: "tip-round"
};
const _hoisted_10 = {
  class: "is-active"
};
const _hoisted_11 = {
  class: "is-active"
};
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "lang-name"
};
const _hoisted_15 = {
  class: "lang-native"
};
const _hoisted_16 = ["innerHTML"];
const _hoisted_17 = {
  key: 4,
  class: "login-btn"
};
const _hoisted_18 = {
  class: "show-m-list-bgc"
};
const _hoisted_19 = {
  class: "profile-icon-body"
};
const _hoisted_20 = {
  key: 0
};
const _hoisted_21 = ["innerHTML"];
const _hoisted_22 = {
  class: "menu-list"
};
const _hoisted_23 = {
  class: "menu-list-title"
};
const _hoisted_24 = {
  class: "menu-list-right"
};
const _hoisted_25 = {
  class: "menu-list"
};
const _hoisted_26 = {
  class: "menu-list-title"
};
const _hoisted_27 = {
  class: "menu-list-right"
};
const _hoisted_28 = {
  class: "menu-list"
};
const _hoisted_29 = {
  class: "menu-list-title"
};
const _hoisted_30 = {
  class: "menu-list-right"
};
const _hoisted_31 = {
  class: "menu-list"
};
const _hoisted_32 = {
  class: "menu-list-title"
};
const _hoisted_33 = {
  key: 0,
  class: "tip-round"
};
const _hoisted_34 = {
  class: "menu-list-right"
};
const _hoisted_35 = {
  class: "menu-list"
};
const _hoisted_36 = {
  class: "menu-list-title"
};
const _hoisted_37 = {
  class: "menu-list-right"
};
const _hoisted_38 = {
  class: "menu-list"
};
const _hoisted_39 = {
  class: "menu-list-title"
};
const _hoisted_40 = {
  class: "menu-list-right"
};
const _hoisted_41 = {
  class: "menu-list"
};
const _hoisted_42 = {
  class: "menu-list-title"
};
const _hoisted_43 = {
  class: "menu-list-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["top-list", [$setup.showList ? 'show-m-list-border' : '']])
  }, [_createElementVNode("div", {
    class: "icon",
    onClick: _cache[0] || (_cache[0] = $event => $setup.goHomePage())
  }, [_createElementVNode("img", {
    src: $setup.logo,
    alt: ""
  }, null, 8, _hoisted_2)]), _createElementVNode("div", {
    class: "top-left-title",
    onClick: _cache[1] || (_cache[1] = $event => $setup.goHomePage())
  }, _toDisplayString(_ctx.$t("qc_sdk_official_recharge")), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: _normalizeClass(["right-title", [$setup.isTabbar == 1 ? 'show-bot-line' : '']]),
    onClick: _cache[2] || (_cache[2] = $event => $setup.goPayPage())
  }, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("qc_sdk_game_list")), 1)], 2), _createElementVNode("div", {
    class: _normalizeClass(["right-title", [$setup.isTabbar == 2 ? 'show-bot-line' : '']]),
    onClick: _cache[3] || (_cache[3] = $event => $setup.goOrderPage())
  }, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("qc_sdk_my_orders")), 1)], 2), _createElementVNode("div", {
    class: _normalizeClass(["right-title", [$setup.isTabbar == 3 ? 'show-bot-line' : '']]),
    onClick: _cache[4] || (_cache[4] = $event => $setup.goExchangePage())
  }, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("qc_sdk_exchange_record")), 1)], 2), _createElementVNode("div", {
    class: _normalizeClass(["right-title", [$setup.isTabbar == 4 ? 'show-bot-line' : '']]),
    onClick: _cache[5] || (_cache[5] = $event => $setup.goPointsDetail())
  }, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("qc_sdk_points_details")), 1)], 2), _createElementVNode("div", {
    class: _normalizeClass(["right-title", [$setup.isTabbar == 5 ? 'show-bot-line' : '']]),
    onClick: _cache[6] || (_cache[6] = $event => $setup.goWarehousePage())
  }, [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("qc_sdk_my_warehouse")), 1), $setup.iconShow ? (_openBlock(), _createElementBlock("div", _hoisted_9)) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
    class: _normalizeClass(["right-title", [$setup.isTabbar == 6 ? 'show-bot-line' : '']]),
    onClick: _cache[7] || (_cache[7] = $event => $setup.goAddressListPage())
  }, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("qc_sdk_my_address")), 1)], 2), $setup.kfUrl ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "right-title",
    onClick: _cache[8] || (_cache[8] = $event => $setup.openKf())
  }, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("qc_sdk_contact_service")), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "click-btn",
    onClick: _cache[9] || (_cache[9] = $event => $setup.showTabrList())
  }, [!$setup.showList ? (_openBlock(), _createElementBlock("img", _hoisted_12)) : _createCommentVNode("", true)]), $setup.showLanguageSelector ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "lang-choice",
    onClick: _cache[11] || (_cache[11] = $event => $setup.choiceLang())
  }, [_cache[26] || (_cache[26] = _createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }, null, -1)), $setup.showLangDropdown ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "lang-dropdown",
    onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.languageList, lang => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["lang-item", {
        active: $setup.currentLang === lang.code
      }]),
      key: lang.code,
      onClick: $event => $setup.handleLanguageChange(lang.code)
    }, [_createElementVNode("span", _hoisted_14, _toDisplayString(lang.name), 1), _createElementVNode("span", _hoisted_15, _toDisplayString(lang.code), 1)], 10, _hoisted_13);
  }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.isPwa == 2 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "click-btn-desktop",
    onClick: _cache[12] || (_cache[12] = $event => $setup.deskTopBtn())
  }, [...(_cache[27] || (_cache[27] = [_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }, null, -1)]))])) : _createCommentVNode("", true), $setup.isPwa == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "click-btn-refresh",
    onClick: _cache[13] || (_cache[13] = $event => $setup.refreshPage())
  }, [...(_cache[28] || (_cache[28] = [_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }, null, -1)]))])) : _createCommentVNode("", true), $setup.type == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "login-btn",
    onClick: _cache[14] || (_cache[14] = $event => $setup.showLogin()),
    innerHTML: _ctx.$t('qc_sdk_hello_log_in')
  }, null, 8, _hoisted_16)) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_createTextVNode(_toDisplayString($setup.mobile) + " ", 1), _createElementVNode("span", {
    onClick: _cache[15] || (_cache[15] = $event => $setup.showLogin()),
    class: "loginout-btn"
  }, _toDisplayString(_ctx.$t("qc_sdk_logout")), 1)]))], 2), _createVNode(_component_van_popup, {
    show: $setup.showList,
    "onUpdate:show": _cache[25] || (_cache[25] = $event => $setup.showList = $event),
    position: $setup.positionType,
    teleport: "#app",
    "overlay-class": "top-popup-overlay"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_cache[29] || (_cache[29] = _createElementVNode("div", {
      class: "profile-icon"
    }, null, -1)), $setup.mobile ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($setup.mobile), 1)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      onClick: _cache[16] || (_cache[16] = $event => $setup.showLogin()),
      innerHTML: _ctx.$t('qc_sdk_hello_log_in')
    }, null, 8, _hoisted_21)), _createElementVNode("div", {
      class: "close-icon",
      onClick: _cache[17] || (_cache[17] = $event => $setup.showList = !$setup.showList)
    })]), _createElementVNode("div", {
      class: "menu-list-container",
      onClick: _cache[18] || (_cache[18] = $event => $setup.goOrderPage())
    }, [_createElementVNode("div", _hoisted_22, [_cache[30] || (_cache[30] = _createElementVNode("div", {
      class: "menu-list-icon"
    }, [_createElementVNode("div", {
      class: "menu-list-icon-wddd"
    })], -1)), _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("qc_sdk_my_orders")), 1), _createElementVNode("div", _hoisted_24, [_createVNode(_component_van_icon, {
      name: "arrow"
    })])])]), _createElementVNode("div", {
      class: "menu-list-container",
      onClick: _cache[19] || (_cache[19] = $event => $setup.goExchangePage())
    }, [_createElementVNode("div", _hoisted_25, [_cache[31] || (_cache[31] = _createElementVNode("div", {
      class: "menu-list-icon"
    }, [_createElementVNode("div", {
      class: "menu-list-icon-dhjl"
    })], -1)), _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("qc_sdk_exchange_record")), 1), _createElementVNode("div", _hoisted_27, [_createVNode(_component_van_icon, {
      name: "arrow"
    })])])]), _createElementVNode("div", {
      class: "menu-list-container",
      onClick: _cache[20] || (_cache[20] = $event => $setup.goPointsDetail())
    }, [_createElementVNode("div", _hoisted_28, [_cache[32] || (_cache[32] = _createElementVNode("div", {
      class: "menu-list-icon"
    }, [_createElementVNode("div", {
      class: "menu-list-icon-jfmx"
    })], -1)), _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("qc_sdk_points_details")), 1), _createElementVNode("div", _hoisted_30, [_createVNode(_component_van_icon, {
      name: "arrow"
    })])])]), _createElementVNode("div", {
      class: "menu-list-container",
      onClick: _cache[21] || (_cache[21] = $event => $setup.goWarehousePage())
    }, [_createElementVNode("div", _hoisted_31, [_cache[33] || (_cache[33] = _createElementVNode("div", {
      class: "menu-list-icon"
    }, [_createElementVNode("div", {
      class: "menu-list-icon-wdck"
    })], -1)), _createElementVNode("div", _hoisted_32, [_createTextVNode(_toDisplayString(_ctx.$t("qc_sdk_my_warehouse")) + " ", 1), $setup.iconShow ? (_openBlock(), _createElementBlock("div", _hoisted_33)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_34, [_createVNode(_component_van_icon, {
      name: "arrow"
    })])])]), _createElementVNode("div", {
      class: "menu-list-container",
      onClick: _cache[22] || (_cache[22] = $event => $setup.goCodeExchangePage())
    }, [_createElementVNode("div", _hoisted_35, [_cache[34] || (_cache[34] = _createElementVNode("div", {
      class: "menu-list-icon"
    }, [_createElementVNode("div", {
      class: "menu-list-icon-zbdh"
    })], -1)), _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("qc_sdk_code_exchange_title")), 1), _createElementVNode("div", _hoisted_37, [_createVNode(_component_van_icon, {
      name: "arrow"
    })])])]), _createElementVNode("div", {
      class: "menu-list-container",
      onClick: _cache[23] || (_cache[23] = $event => $setup.goAddressListPage())
    }, [_createElementVNode("div", _hoisted_38, [_cache[35] || (_cache[35] = _createElementVNode("div", {
      class: "menu-list-icon"
    }, [_createElementVNode("div", {
      class: "menu-list-icon-wddz"
    })], -1)), _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("qc_sdk_my_address")), 1), _createElementVNode("div", _hoisted_40, [_createVNode(_component_van_icon, {
      name: "arrow"
    })])])]), $setup.kfUrl ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "menu-list-container",
      onClick: _cache[24] || (_cache[24] = $event => $setup.openKf())
    }, [_createElementVNode("div", _hoisted_41, [_cache[36] || (_cache[36] = _createElementVNode("div", {
      class: "menu-list-icon"
    }, [_createElementVNode("div", {
      class: "menu-list-icon-lxkf"
    })], -1)), _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("qc_sdk_contact_service")), 1), _createElementVNode("div", _hoisted_43, [_createVNode(_component_van_icon, {
      name: "arrow"
    })])])])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["show", "position"])]);
}